/* eslint-disable react-hooks/exhaustive-deps */
import React, {
  useEffect, useState, useContext, useRef, Fragment,
} from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash/fp';
import moment from 'moment';
import 'moment/locale/th';
import Papa from 'papaparse';
import { useTranslation } from 'react-i18next';
import { useLocation, useHistory } from 'react-router-dom';

import { makeStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import Hidden from '@material-ui/core/Hidden';
import Snackbar from '@material-ui/core/Snackbar';
import Slide from '@material-ui/core/Slide';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import CookieConsent from 'react-cookie-consent';
import MuiAlert from '@material-ui/lab/Alert';
import WarningIcon from '@material-ui/icons/Warning';
import InfoIcon from '@material-ui/icons/Info';
import DvrIcon from '@material-ui/icons/Dvr';
import RoomIcon from '@material-ui/icons/Room';
// leaflet
import L from 'leaflet';
import 'leaflet-kmz';
import {
  Map, TileLayer,
} from 'react-leaflet';

import HeaderMap from '../../containers/Header/HeaderMap';
import FooterMap from '../../containers/Footer/FooterMap';

import { StyledSidebarButton } from '../../components/button/Button';
import Modal from '../../components/modal/Modal';

// css
import 'leaflet/dist/leaflet.css';
import '../../components/map/Style.css';
import './leaflet.css';

// style
import { styles, StyledBadge } from './style';

import RainData from './rain/RainData';
import Rain24List from './rain/RainList';
import Rain24DetailList from './rain/RainDetailList';
import Rain24Map from './rain/RainMap';

import WaterLevelData from './waterLevel/WaterLevelData';
import WaterLevelList from './waterLevel/WaterLevelList';
import WaterLevelDetailList from './waterLevel/WaterLevelDetailList';
import WaterLevelMap from './waterLevel/WaterLevelMap';

import WaterQualityData from './waterQuality/WaterQualityData';
import WaterQualityList from './waterQuality/WaterQualityList';
import WaterQualityDetailList from './waterQuality/WaterQualityDetailList';
import WaterQualityMap from './waterQuality/WaterQualityMap';

import WaveData from './wave/WaveData';
import WaveList from './wave/WaveList';
import WaveDetailList from './wave/WaveDetailList';
import WaveMap from './wave/WaveMap';
// import { mockDataWave } from './wave/mockDataTest';

// storm
import StormList from './storm/StormList';
import Jtwc from '../../components/map/storm/Jtwc';

// import StormData from './storm/StormData';
// import StormLatest from '../../components/map/storm/StormLatest';
// import SampleTrack from '../../assets/sample/storm.json';
// import SampleKmz from '../../assets/sample/ep0620.kmz';

// dam
import DamData from './dam/DamData';
import DamList from './dam/DamList';
import DamDetailList from './dam/DamDetailList';
import DamMap from './dam/DamMap';

// import AnnounceList from './announce/AnnounceList';

import DisasterData from './disaster/DisasterData';
import DisasterList from './disaster/DisasterList';
import DisasterDetailList from './disaster/DisasterDetailList';
import DisasterMap from './disaster/DisasterMap';

import EwsWarningData from './earlyWarning/EwsWarningData';
import EarlyWarningList from './earlyWarning/EarlyWarningList';
import EarlyWarningDetailList from './earlyWarning/EarlyWarningDetailList';
import EarlyWarningMap from './earlyWarning/EarlyWarningMap';

import RainfallForecastList from './forecast/rainfall/RainfallForecastList';
import RainfallForecastMap from './forecast/rainfall/RainfallForecastMap';

import DroughtData from './forecast/drought/DroughtData';
import DroughtList from './forecast/drought/DroughtList';
import DroughtDetailList from './forecast/drought/DroughtDetailList';

import SalinityData from './forecast/salinity/SalinityData';
import SalinityList from './forecast/salinity/SalinityList';
import SalinityDetailList from './forecast/salinity/SalinityDetailList';

import FlashfloodData from './forecast/flashflood/FlashfloodData';
import FlashfloodList from './forecast/flashflood/FlashfloodList';
import FlashfloodDetailList from './forecast/flashflood/FlashfloodDetailList';

import SituationList from './situation/SituationList';

// import {testrain} from './rain/testrain';
import MapLegend from './legend/Legend';

// wms boundary
import WmsBoundary from '../../components/map/WmsBoundary';
import WmsBasin from '../../components/map/WmsBasin';

// layers
import LayerRiver from '../../components/map/River';
import LayerProvince from '../../components/map/Province';
import LayerBasin from '../../components/map/Basin';

import ThailandJson from '../../assets/map/geojson/thailand.json';

// Provider
import ModeContext from '../../context/ModeContext';
import UserContext from '../../context/UserContext';

// logo
import Logo from '../../assets/logos/allforone_onwr-logo-small.png';

// banner feedback
import HandIcon from '../../assets/icons/hand.png';

// config
import mapConfig from '../../components/map/Config';
import {
  QualityIcon,
  RainIcon,
  WaterLevelIcon,
  DamIcon,
  // AlertIcon,
  StormIcon,
  RainfallIcon,
  WaveIcon,
  SuddenIcon,
  DroughtIcon,
  SalinityIcon,
  EwsOutlineIcon,
} from '../../assets/svg/Icon';
// import { event } from 'react-ga';
// import InfographBasin from './situation/InfographBasin';

const initPath = `/${process.env.REACT_APP_PATH}`;
const useStyles = makeStyles(styles);

function LogoHeader() {
  const classes = useStyles();
  return (
    <Box mt={{ xs: 1, sm: 1, md: 1 }} className={classes.positionBox}>
      <img src={Logo} alt="onwr" className={classes.imgLogo} />
    </Box>
  );
}

// -------------------------------------------
export default function Main() {
  const location = useLocation();
  const history = useHistory();
  const { i18n } = useTranslation();
  const classes = useStyles();

  const mainData = useRef({});
  const refMap = useRef(null);

  const { currentMode, currentArea } = useContext(ModeContext);
  const { userIsLogin } = useContext(UserContext);

  const [open, setOpen] = useState(false);
  const [openNoti, setOpenNoti] = useState(true);
  const [openHatyai68, setOpenHatyai68] = useState(true);
  const [openHatyaiFlood, setOpenHatyaiFlood] = useState(true);
  const [openStationFloodArea, setOpenStationFloodArea] = useState(true);
  const [openModal, setOpenModal] = useState(true);
  const [openBanner, setOpenBanner] = useState(true);
  const [openAlertThaid, setOpenAlertThaid] = useState(true);
  const [transition, setTransition] = useState(undefined);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [error, setError] = useState('');
  const [isLoading, setLoading] = useState(true);
  const [modalData, setModalData] = useState({
    header: '',
    subheader: null,
    content: null,
  });

  const [thaidStatus, setThaidStatus] = useState('');
  const [pagename, setPageName] = useState('');
  const [dataAll, setDataAll] = useState({
    rainList: {},
    dataRain: [],
    rainCount: [],
    waveCount: [],
    waveList: {},
    dataWave: [],
    wqCount: [],
    wqList: {},
    dataWaterQuality: [],
    wlRedCount: [],
    wlList: {},
    dataWaterLevel: [],
    dataDam: {},
    damCount: [],
    dataStorm: [],
    stormCount: [],
    dataRainfallForecast: [],
    dataDisaster: [],
    dataDrought: [],
    dataSalinity: [],
    dataFlashflood: [],
    dataSituationAlert: [],
    dataEarlyWarning: [],
  });
  const thailandJson = ThailandJson;
  const FETCH_TIMEOUT = 10000; // 10 seconds

  // วันเวลาปัจจุบัน -1 ชั่วโมง ที่ .00
  const dataTime = `${moment().add(-1, 'hours').startOf('hour').format('HH:mm')} น.`;

  let rainData;
  let waveData;
  let wqData;
  let wlData;
  let damData;
  let stormDatas;
  let dataRainfallForecast;
  let dataDisaster;
  let dataDrought;
  let dataSalinity;
  let dataFlashflood;
  let dataEarlyWarning;

  const handleOpenLegend = (header, legendname) => (e) => {
    e.preventDefault();
    setIsModalOpen(true);
    setModalData({
      header,
      subheader: null,
      content: <MapLegend legend={legendname} />,
    });
  };

  const handleClick = (Transition, name) => () => {
    setPageName(name);
    setTransition(() => Transition);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  function handleModalClose() {
    setIsModalOpen(false);
  }

  function closeAlertThaid() {
    setOpenAlertThaid(false);
    history.push(`/${process.env.REACT_APP_PATH}`);
  }

  const handleRainDetailList = (data) => (e) => {
    e.preventDefault();
    setIsModalOpen(true);
    setModalData({
      header: i18n.language === 'en' ? (
        <Typography variant="h6">
          Alert on the Latest
          <Typography variant="h6" color="primary" display="inline">
            <Box px={1} display="inline">&quot;Rainfall&quot;</Box>
          </Typography>
          Situation
        </Typography>
      ) : (
        <Typography variant="h6">
          แจ้งเตือนสถานการณ์
          <Typography variant="h6" color="primary" display="inline">
            <Box px={1} display="inline">&quot;ฝน&quot;</Box>
          </Typography>
          ล่าสุด
        </Typography>
      ),
      subheader: null,
      content: <Rain24DetailList datas={data} userIsLogin={userIsLogin} />,
    });
  };

  const handleWaterLevelDetailList = (data) => (e) => {
    e.preventDefault();
    setIsModalOpen(true);
    setModalData({
      header: i18n.language === 'en' ? (
        <Typography variant="h6">
          Alert on the Latest
          <Typography variant="h6" color="primary" display="inline">
            <Box px={1} display="inline">&quot;Water Level&quot;</Box>
          </Typography>
          Situation
        </Typography>
      ) : (
        <Typography variant="h6">
          แจ้งเตือนสถานการณ์
          <Typography variant="h6" color="primary" display="inline">
            <Box px={1} display="inline">&quot;ระดับน้ำ&quot;</Box>
          </Typography>
          ล่าสุด
        </Typography>
      ),
      subheader: null,
      content: <WaterLevelDetailList datas={data} userIsLogin={userIsLogin} />,
    });
  };

  const handleWaterQualityDetailList = (data) => (e) => {
    e.preventDefault();
    setIsModalOpen(true);
    setModalData({
      header: i18n.language === 'en' ? (
        <Typography variant="h6">
          Alert on the Latest
          <Typography variant="h6" color="primary" display="inline">
            <Box px={1} display="inline">&quot;Rainfall&quot;</Box>
          </Typography>
          Situation
        </Typography>
      ) : (
        <Typography variant="h6">
          แจ้งเตือนสถานการณ์
          <Typography variant="h6" color="primary" display="inline">
            <Box px={1} display="inline">&quot;คุณภาพน้ำ&quot;</Box>
          </Typography>
          ล่าสุด
        </Typography>
      ),
      subheader: null,
      content: <WaterQualityDetailList datas={data} userIsLogin={userIsLogin} />,
    });
  };

  const handleWaveDetailList = (data) => (e) => {
    e.preventDefault();
    setIsModalOpen(true);
    setModalData({
      header: i18n.language === 'en' ? (
        <Typography variant="h6">
          Alert on the Latest
          <Typography variant="h6" color="primary" display="inline">
            <Box px={1} display="inline">&quot;Wave Forecast&quot;</Box>
          </Typography>
          Situation
        </Typography>
      ) : (
        <Typography variant="h6">
          แจ้งเตือนสถานการณ์
          <Typography variant="h6" color="primary" display="inline">
            <Box px={1} display="inline">&quot;คาดการณ์คลื่น&quot;</Box>
          </Typography>
          ล่าสุด
        </Typography>
      ),
      subheader: null,
      content: <WaveDetailList datas={data} userIsLogin={userIsLogin} />,
    });
  };

  const handleDamDetailList = (data) => (e) => {
    e.preventDefault();
    setIsModalOpen(true);
    setModalData({
      header: i18n.language === 'en' ? (
        <Typography variant="h6">
          Alert on the Latest
          <Typography variant="h6" color="primary" display="inline">
            <Box px={1} display="inline">&quot;Large Reservoirs&quot;</Box>
          </Typography>
          Situation
        </Typography>
      ) : (
        <Typography variant="h6">
          แจ้งเตือนสถานการณ์
          <Typography variant="h6" color="primary" display="inline">
            <Box px={1} display="inline">&quot;แหล่งน้ำขนาดใหญ่&quot;</Box>
          </Typography>
          ล่าสุด
        </Typography>
      ),
      subheader: null,
      content: <DamDetailList datas={data} userIsLogin={userIsLogin} />,
    });
  };

  const handleDisasterDetailList = (data) => (e) => {
    e.preventDefault();
    setIsModalOpen(true);
    setModalData({
      header: i18n.language === 'en' ? (
        <Typography variant="h6">
          Alert on the Latest
          <Typography variant="h6" color="primary" display="inline">
            <Box px={1} display="inline">&quot;Declared Disaster Area&quot;</Box>
          </Typography>
          Situation
        </Typography>
      ) : (
        <Typography variant="h6">
          แจ้งเตือนสถานการณ์
          <Typography variant="h6" color="primary" display="inline">
            <Box px={1} display="inline">&quot;พื้นที่ประกาศภัย&quot;</Box>
          </Typography>
          ล่าสุด
        </Typography>
      ),
      subheader: null,
      content: <DisasterDetailList datas={data} userIsLogin={userIsLogin} />,
    });
  };

  const handleEarlyWarningDetailList = (data) => (e) => {
    e.preventDefault();
    setIsModalOpen(true);
    setModalData({
      header: i18n.language === 'en' ? (
        <Typography component="span" variant="h6">
          Alert on the Latest
          <Typography variant="h6" color="primary" display="inline">
            <Box px={1} display="inline">&quot;Early Warning Area&quot;</Box>
          </Typography>
          Situation
        </Typography>
      ) : (
        <Typography component="span" variant="h6">
          แจ้งเตือนสถานการณ์
          <Typography variant="h6" color="primary" display="inline">
            <Box px={1} display="inline">&quot;เตือนภัยน้ำหลากดินถล่ม (EWS)&quot;</Box>
          </Typography>
          ล่าสุด
        </Typography>
      ),
      subheader: (
        <>
          แหล่งข้อมูล :
          {' '}
          <Link href="http://ews.dwr.go.th" target="_blank" title="http://ews.dwr.go.th">http://ews.dwr.go.th</Link>
        </>
      ),
      content: <EarlyWarningDetailList datas={data ? data.item : []} userIsLogin={userIsLogin} />,
    });
  };

  const handleFlashfloodDetailList = (data) => (e) => {
    e.preventDefault();
    setIsModalOpen(true);
    setModalData({
      header: i18n.language === 'en' ? (
        <Typography variant="h6">
          Alert on the Latest
          <Typography variant="h6" color="primary" display="inline">
            <Box px={1} display="inline">&quot;Flash Flood Forecast&quot;</Box>
          </Typography>
          Situation
        </Typography>
      ) : (
        <Typography variant="h6">
          แจ้งเตือนสถานการณ์
          <Typography variant="h6" color="primary" display="inline">
            <Box px={1} display="inline">&quot;คาดการณ์น้ำท่วมฉับพลัน&quot;</Box>
          </Typography>
          ล่าสุด
        </Typography>
      ),
      subheader: null,
      content: <FlashfloodDetailList datas={data} userIsLogin={userIsLogin} />,
    });
  };

  const handleDroughtDetailList = (data) => (e) => {
    e.preventDefault();
    setIsModalOpen(true);
    setModalData({
      header: i18n.language === 'en' ? (
        <Typography variant="h6">
          Alert on the Latest
          <Typography variant="h6" color="primary" display="inline">
            <Box px={1} display="inline">&quot;Drought Monitor&quot;</Box>
          </Typography>
          Situation
        </Typography>
      ) : (
        <Typography variant="h6">
          แจ้งเตือนสถานการณ์
          <Typography variant="h6" color="primary" display="inline">
            <Box px={1} display="inline">&quot;ติดตามภัยแล้ง&quot;</Box>
          </Typography>
          ล่าสุด
        </Typography>
      ),
      subheader: null,
      content: <DroughtDetailList datas={data} userIsLogin={userIsLogin} />,
    });
  };

  const handleSalinityDetailList = (data) => (e) => {
    e.preventDefault();
    setIsModalOpen(true);
    setModalData({
      header: i18n.language === 'en' ? (
        <Typography variant="h6">
          Alert on the Latest
          <Typography variant="h6" color="primary" display="inline">
            <Box px={1} display="inline">&quot;Salinity Forecast;</Box>
          </Typography>
          Situation
        </Typography>
      ) : (
        <Typography variant="h6">
          แจ้งเตือนสถานการณ์
          <Typography variant="h6" color="primary" display="inline">
            <Box px={1} display="inline">&quot;คาดการณ์ความเค็ม&quot;</Box>
          </Typography>
          ล่าสุด
        </Typography>
      ),
      subheader: null,
      content: <SalinityDetailList datas={data} userIsLogin={userIsLogin} />,
    });
  };

  const handleSituationAlert = (data) => (e) => {
    e.preventDefault();
    setIsModalOpen(true);
    setModalData({
      header: i18n.language === 'en' ? (
        <Typography component="span" variant="h6">
          Alert on the Latest
          <Typography variant="h6" color="primary" display="inline">
            <Box px={1} display="inline">&quot;Alert&quot;</Box>
          </Typography>
          Situation
        </Typography>
      ) : (
        <Typography component="span" variant="h6">
          ประกาศ&nbsp;
          <Typography variant="h6" color="primary" display="inline">
            <Box px={1} display="inline">&quot;แจ้งเตือนสถานการณ์&quot;</Box>
          </Typography>
          ล่าสุด
        </Typography>
      ),
      // subheader: (
      //   <>
      //     แหล่งข้อมูล :
      //     {' '}
      //     <Link href="https://news.onwr.go.th" target="_blank" title="https://news.onwr.go.th">https://news.onwr.go.th</Link>
      //   </>
      // ),
      content: <SituationList datas={data} userIsLogin={userIsLogin} />,
    });
  };

  // const handleSituationAlertBasin = () => (e) => {
  //   e.preventDefault();
  //   setIsModalOpen(true);
  //   setModalData({
  //     header: i18n.language === 'en' ? (
  //       <Typography component="span" variant="h6">
  //         Infographic monitoring the river basin situation
  //       </Typography>
  //     ) : (
  //       <Typography component="span" variant="h6">
  //         อินโฟกราฟิกติดตามสถานการณ์ลุ่มน้ำ
  //       </Typography>
  //     ),

  //     content: <InfographBasin />,
  //   });
  // };

  const handlenewtabSituation = () => (e) => {
    e.preventDefault();
    window.open(
      `${initPath}infographic-basin-situation`,
      '_blank',
    );
  };

  function TransitionLeft(props) {
    // eslint-disable-next-line react/jsx-props-no-spreading
    return <Slide {...props} direction="left" />;
  }

  // --------------------------- view
  function StationLeft() {
    return (
      <>
        <Box className={classes.boxViewHeadLeft}>
          <LogoHeader />
        </Box>

        {/* Rain */}
        <Rain24List
          datas={dataAll.rainList}
          dataDetail={dataAll.dataRain}
          handleRainDetailList={handleRainDetailList}
          handleOpenLegend={handleOpenLegend}
        />

        {/* water level */}
        <WaterLevelList
          datas={dataAll.wlList}
          dataDetail={dataAll.dataWaterLevel}
          handleWaterLevelDetailList={handleWaterLevelDetailList}
          handleOpenLegend={handleOpenLegend}
        />

        {/* dam */}
        <DamList
          datas={dataAll.dataDam}
          handleDetailList={handleDamDetailList}
          handleOpenLegend={handleOpenLegend}
        />

        {/* water quality */}
        <WaterQualityList
          datas={dataAll.wqList}
          handleWaterQualityDetailList={handleWaterQualityDetailList}
          handleOpenLegend={handleOpenLegend}
        />

        {/* disaster */}
        {/* <DisasterList
          datas={dataAll.dataDisaster}
          handleDisasterDetailList={handleDisasterDetailList}
        /> */}

        {/* announce */}
        {/* <AnnounceList
          datas={dataAll.dataDisaster}
          handleDisasterDetailList={handleDisasterDetailList}
        /> */}

        {/* {Early Warning System(ews)} */}
        <EarlyWarningList
          datas={dataAll.dataEarlyWarning}
          handleEarlyWarningDetailList={handleEarlyWarningDetailList}
          handleOpenLegend={handleOpenLegend}
        />
      </>
    );
  }

  function StationRight() {
    return (
      <>
        <Box className={classes.boxViewHeadRight}>
          <HeaderMap />
        </Box>

        {/* storm */}
        <StormList
          datas={dataAll.dataStorm}
          handleOpenLegend={handleOpenLegend}
        />

        {/* wave forecast (swan) */}
        <WaveList
          datas={dataAll.waveList}
          dataDetail={dataAll.dataWave}
          handleWaveDetailList={handleWaveDetailList}
          handleOpenLegend={handleOpenLegend}
        />

        {/* rainfall forecast */}
        <RainfallForecastList
          datas={dataAll.dataRainfallForecast}
          currentMode={currentMode}
          currentAreaCode={currentArea.code}
          handleOpenLegend={handleOpenLegend}
          userIsLogin={userIsLogin}
        />

        {/* drought */}
        <DroughtList
          datas={dataAll.dataDrought}
          handleDroughtDetailList={handleDroughtDetailList}
          userIsLogin={userIsLogin}
        />

        {/* salinity */}
        <SalinityList
          datas={dataAll.dataSalinity}
          handleSalinityDetailList={handleSalinityDetailList}
          userIsLogin={userIsLogin}
        />

        {/* flashflood */}
        <FlashfloodList
          datas={dataAll.dataFlashflood}
          handleFlashfloodDetailList={handleFlashfloodDetailList}
          userIsLogin={userIsLogin}
        />
      </>
    );
  }

  function BoxView() {
    return (
      <>
        {/* left */}
        <Box alignItems="center" style={{}}>
          {/* <LogoHeader /> */}
          <StationLeft />
        </Box>

        {/* right */}
        <Box alignItems="center">
          {/* <HeaderMap /> */}
          <StationRight />
        </Box>
      </>
    );
  }

  function Mobile() {
    return (
      <>
        <Box display="block" className={classes.boxViewLeft}>
          <Box><LogoHeader /></Box>
        </Box>
        <Box className={classes.boxViewHeader}>
          <Box><HeaderMap /></Box>
        </Box>
        <Box>
          <Snackbar
            open={open}
            onClose={handleClose}
            TransitionComponent={transition}
            message={<StationPopup page={pagename} />}
            key={transition ? transition.name : ''}
            className={classes.boxViewSnackbar}
          />
        </Box>
        <Box display="block" className={classes.boxContentMobile}>
          <Box display="block" className={classes.boxMobile}>
            <Grid container spacing={3} direction="column" justifyContent="flex-end" alignItems="flex-end">
              <Grid item>
                <Box display="flex" className={classes.shapeCircle} alignItems="center" justifyContent="center">
                  <StyledSidebarButton
                    id="main-rainfall-mb"
                    onClick={handleClick(TransitionLeft, 'rain')}
                  >
                    <StyledBadge
                      badgeContent={dataAll.rainCount}
                      overlap="circular"
                      color="secondary"
                    >
                      <RainIcon style={{ color: 'white' }} />
                    </StyledBadge>
                  </StyledSidebarButton>
                </Box>
              </Grid>
              <Grid item>
                <Box display="flex" className={classes.shapeCircle} alignItems="center" justifyContent="center">
                  <StyledSidebarButton
                    id="main-waterlevel-mb"
                    onClick={handleClick(TransitionLeft, 'waterlevel')}
                  >
                    <StyledBadge
                      badgeContent={dataAll.wlRedCount}
                      overlap="circular"
                      color="secondary"
                    >
                      <WaterLevelIcon style={{ color: 'white' }} />
                    </StyledBadge>
                  </StyledSidebarButton>
                </Box>
              </Grid>
              <Grid item>
                <Box display="flex" className={classes.shapeCircle} alignItems="center" justifyContent="center">
                  <StyledSidebarButton
                    id="main-dam-mb"
                    onClick={handleClick(TransitionLeft, 'dam')}
                  >
                    <StyledBadge
                      badgeContent={dataAll.damCount}
                      overlap="circular"
                      color="secondary"
                    >
                      <DamIcon style={{ color: 'white' }} />
                    </StyledBadge>
                  </StyledSidebarButton>
                </Box>
              </Grid>
              <Grid item>
                <Box display="flex" className={classes.shapeCircle} alignItems="center" justifyContent="center">
                  <StyledSidebarButton
                    id="main-waterquality-mb"
                    onClick={handleClick(TransitionLeft, 'waterquality')}
                  >
                    <StyledBadge
                      badgeContent={dataAll.wqCount}
                      overlap="circular"
                      color="secondary"
                    >
                      <QualityIcon style={{ color: 'white' }} />
                    </StyledBadge>
                  </StyledSidebarButton>
                </Box>
              </Grid>
              {/* <Grid item>
                <Box
                display="flex"
                  className={classes.shapeCircle}
                  alignItems="center"
                    justifyContent="center">
                  <StyledSidebarButton
                    id="main-alert-mb"
                    onClick={handleClick(TransitionLeft, 'risk')}
                  >
                    <StyledBadge
                      badgeContent={dataAll.dataDisaster.count}
                      overlap="circular"
                      color="secondary"
                    >
                      <AlertIcon style={{ color: 'white' }} />
                    </StyledBadge>
                  </StyledSidebarButton>
                </Box>
              </Grid> */}
              <Grid item>
                <Box display="flex" className={classes.shapeCircle} alignItems="center" justifyContent="center">
                  <StyledSidebarButton
                    id="main-warning-mb"
                    onClick={handleClick(TransitionLeft, 'ews')}
                  >
                    <StyledBadge
                      badgeContent={(dataAll.dataEarlyWarning?.summary?.evacuate !== 'undefined') ? dataAll.dataEarlyWarning?.summary?.evacuate : ''}
                      overlap="circular"
                      color="secondary"
                    >
                      <EwsOutlineIcon style={{ color: 'white' }} />
                    </StyledBadge>
                  </StyledSidebarButton>
                </Box>
              </Grid>
              <Grid item>
                <Box display="flex" className={classes.shapeCircle} alignItems="center" justifyContent="center">
                  <StyledSidebarButton
                    id="main-storm-mb"
                    onClick={handleClick(TransitionLeft, 'storm')}
                  >
                    <StyledBadge
                      badgeContent={dataAll.stormCount}
                      overlap="circular"
                      color="secondary"
                    >
                      <StormIcon style={{ color: 'white' }} />
                    </StyledBadge>
                  </StyledSidebarButton>
                </Box>
              </Grid>
              <Grid item>
                <Box display="flex" className={classes.shapeCircle} alignItems="center" justifyContent="center">
                  <StyledSidebarButton
                    id="main-rainfall-forecast-mb"
                    onClick={handleClick(TransitionLeft, 'rainforecast')}
                  >
                    <StyledBadge
                      overlap="circular"
                      color="secondary"
                    >
                      <RainfallIcon style={{ color: 'white' }} />
                    </StyledBadge>
                  </StyledSidebarButton>
                </Box>
              </Grid>
              <Grid item>
                <Box display="flex" className={classes.shapeCircle} alignItems="center" justifyContent="center">
                  <StyledSidebarButton
                    id="main-wave-mb"
                    onClick={handleClick(TransitionLeft, 'wave')}
                  >
                    <StyledBadge
                      badgeContent={dataAll.waveCount}
                      overlap="circular"
                      color="secondary"
                    >
                      <WaveIcon style={{ color: 'white' }} />
                    </StyledBadge>
                  </StyledSidebarButton>
                </Box>
              </Grid>
              <Grid item>
                <Box display="flex" className={classes.shapeCircle} alignItems="center" justifyContent="center">
                  <StyledSidebarButton
                    id="main-sudden-mb"
                    onClick={handleClick(TransitionLeft, 'flood')}
                  >
                    <StyledBadge
                      badgeContent={dataAll.dataFlashflood.count}
                      overlap="circular"
                      color="secondary"
                    >
                      <SuddenIcon style={{ color: 'white' }} />
                    </StyledBadge>
                  </StyledSidebarButton>
                </Box>
              </Grid>
              <Grid item>
                <Box display="flex" className={classes.shapeCircle} alignItems="center" justifyContent="center">
                  <StyledSidebarButton
                    id="main-salinity-mb"
                    onClick={handleClick(TransitionLeft, 'salinity')}
                  >
                    <StyledBadge
                      badgeContent={dataAll.dataSalinity.count}
                      overlap="circular"
                      color="secondary"
                    >
                      <SalinityIcon style={{ color: 'white' }} />
                    </StyledBadge>
                  </StyledSidebarButton>
                </Box>
              </Grid>
              <Grid item>
                <Box display="flex" className={classes.shapeCircle} alignItems="center" justifyContent="center">
                  <StyledSidebarButton
                    id="main-drought-mb"
                    onClick={handleClick(TransitionLeft, 'drought')}
                  >
                    <StyledBadge
                      badgeContent={dataAll.dataDrought.count}
                      overlap="circular"
                      color="secondary"
                    >
                      <DroughtIcon style={{ color: 'white' }} />
                    </StyledBadge>
                  </StyledSidebarButton>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Box>
      </>
    );
  }

  function StationPopup(props) {
    const { page } = props;
    // console.log(page);

    return (
      <>
        {page === 'rain' && (
          <Rain24List
            datas={dataAll.rainList}
            dataDetail={dataAll.dataRain}
            handleRainDetailList={handleRainDetailList}
            handleOpenLegend={handleOpenLegend}
            mobilemode
          />
        )}
        {page === 'waterlevel' && (
          <WaterLevelList
            datas={dataAll.wlList}
            dataDetail={dataAll.dataWaterLevel}
            handleWaterLevelDetailList={handleWaterLevelDetailList}
            handleOpenLegend={handleOpenLegend}
            mobilemode
          />
        )}

        {page === 'dam' && (
          <DamList
            datas={dataAll.dataDam}
            handleDetailList={handleDamDetailList}
            handleOpenLegend={handleOpenLegend}
            mobilemode
          />
        )}

        {page === 'waterquality' && (
          <WaterQualityList
            datas={dataAll.wqList}
            handleWaterQualityDetailList={handleWaterQualityDetailList}
            handleOpenLegend={handleOpenLegend}
            mobilemode
          />
        )}

        {page === 'risk' && (
          <DisasterList
            datas={dataAll.dataDisaster}
            currentMode={currentMode}
            currentAreaCode={currentArea.code}
            handleDisasterDetailList={handleDisasterDetailList}
            mobilemode
          />
        )}

        {page === 'ews' && (
          <EarlyWarningList
            datas={dataAll.dataEarlyWarning}
            currentMode={currentMode}
            handleEarlyWarningDetailList={handleEarlyWarningDetailList}
            handleOpenLegend={handleOpenLegend}
            mobilemode
          />
        )}

        {page === 'drought' && (
          <DroughtList
            datas={dataAll.dataDrought}
            currentMode={currentMode}
            currentAreaCode={currentArea.code}
            thailandJson={thailandJson}
            handleDroughtDetailList={handleDroughtDetailList}
            mobilemode
            userIsLogin={userIsLogin}
          />
        )}

        {page === 'salinity' && (
          <SalinityList
            datas={dataAll.dataSalinity}
            currentMode={currentMode}
            currentAreaCode={currentArea.code}
            thailandJson={thailandJson}
            handleSalinityDetailList={handleSalinityDetailList}
            mobilemode
            userIsLogin={userIsLogin}
          />
        )}

        {page === 'flood' && (
          <FlashfloodList
            datas={dataAll.dataFlashflood}
            currentMode={currentMode}
            currentAreaCode={currentArea.code}
            thailandJson={thailandJson}
            handleFlashfloodDetailList={handleFlashfloodDetailList}
            mobilemode
            userIsLogin={userIsLogin}
          />
        )}
        {page === 'storm' && (
          <StormList
            datas={dataAll.dataStorm}
            handleOpenLegend={handleOpenLegend}
            mobilemode
          />
        )}
        {page === 'wave' && (
          <WaveList
            datas={dataAll.waveList}
            dataDetail={dataAll.dataWave}
            handleWaveDetailList={handleWaveDetailList}
            handleOpenLegend={handleOpenLegend}
            mobilemode
          />
        )}
        {page === 'rainforecast' && (
          <RainfallForecastList
            datas={dataAll.dataRainfallForecast}
            currentMode={currentMode}
            currentAreaCode={currentArea.code}
            handleOpenLegend={handleOpenLegend}
            mobilemode
          />
        )}
      </>

    );
  }

  // -------- data --------

  function setRain(datas) {
    return RainData(currentMode, currentArea, datas, dataTime);
  }

  function setWaveData(datas) {
    return WaveData(currentMode, currentArea, datas);
  }

  function setWaterQualityData(datas) {
    return WaterQualityData(currentMode, currentArea, datas, dataTime);
  }

  function setWlData(datas) {
    return WaterLevelData(currentMode, currentArea, datas, dataTime);
  }

  function setDam(datas) {
    return DamData(currentMode, currentArea, datas, dataTime);
  }

  function setDisaster(datas) {
    return DisasterData(currentMode, currentArea, datas, dataTime);
  }

  function setDrought(datas) {
    return DroughtData(currentMode, currentArea, datas, dataTime, thailandJson);
  }

  function setSalinity(datas) {
    return SalinityData(currentMode, currentArea, datas, dataTime, thailandJson);
  }

  function setFlashflood(datas) {
    return FlashfloodData(currentMode, currentArea, datas, dataTime, thailandJson);
  }

  function setEwsWarning(datas) {
    return EwsWarningData(currentMode, currentArea, datas);
  }

  function Alert(props) {
    // eslint-disable-next-line react/jsx-props-no-spreading
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  }

  async function getData(Url, resType) {
    try {
      const response = await fetch(Url).catch((err) => { throw new Error('Can not fetch', err); });
      if (response.status === 200) {
        return resType ? await response.text() : await response.json();
      }
      return resType ? null : {};
    } catch (err) {
      if (resType === 'text') {
        return [];
      }
      return err;
    }
  }

  useEffect(() => {
    // 2023-07-24 พบปัญหาหน้า load ช้า timeout แยกไป fetch ต่างหาก
    // const fourPromise = getData(`${process.env.REACT_APP_FEWS_URL}/model-output/data_portal/mwa_salinity/warning_salinity.csv`, 'text');
    // const sevenPromise = getData(`${process.env.REACT_APP_API_BACKOFFICE_URL}/risk/dwr/ews`);

    const fetchData = () => {
      const firstPromise = getData(`${process.env.REACT_APP_API_URL}/public/thailand`);
      const secondPromise = getData(`${process.env.REACT_APP_API_BACKOFFICE_URL}/disaster`);
      const thirdPromise = getData(`${process.env.REACT_APP_FEWS_URL}/model-output/data_portal/flashflood/flashflood_report.txt`, 'text');
      const fivePromise = getData(`${process.env.REACT_APP_FEWS_URL}/model-output/data_portal/drought/drought_report.txt`, 'text');
      const sixPromise = getData(`${process.env.REACT_APP_API_BACKOFFICE_URL}/onwr/content/announce`);

      Promise.all([
        firstPromise,
        secondPromise,
        thirdPromise,
        fivePromise,
        sixPromise,
      ])
        .then(([
          result, resultDisaster, resultFlashFlood,
          resutDrought, resultSituation,
        ]) => {
          mainData.current.thailand = result;
          rainData = setRain(result.rain);
          wqData = setWaterQualityData(result.waterquality.data.data);
          wlData = setWlData(result.waterlevel.data.data);
          waveData = setWaveData(result.wave.data.data);
          stormDatas = result.storm.data.data;
          damData = setDam(result.dam.data.data);
          dataRainfallForecast = result.pre_rain.data.data;

          mainData.current.dis = resultDisaster;
          dataDisaster = setDisaster(resultDisaster.data);

          const flashfloodArray = Papa.parse(resultFlashFlood).data.slice(1, -1);
          mainData.current.flashflood = flashfloodArray;
          dataFlashflood = setFlashflood(flashfloodArray);

          const droughtArray = Papa.parse(resutDrought).data.slice(1, -1);
          mainData.current.drought = droughtArray;
          dataDrought = setDrought(droughtArray);

          const situationAlert = resultSituation.success ? resultSituation.data : [];

          const varDataAll = {
            rainList: rainData.RainList,
            dataRain: rainData.dataFilterArea,
            rainCount: rainData.RainList.count,
            waveCount: waveData.waveCount,
            waveList: waveData.waveList,
            dataWave: waveData.waveDataFilterArea,
            wqCount: wqData.wqCount,
            wqList: wqData.wqList,
            dataWaterQuality: wqData.wqFilterLevel,
            wlRedCount: wlData.wlRedCount,
            wlList: wlData.wlList,
            dataWaterLevel: wlData.wlFilterLevel,
            dataDam: damData.damList,
            damCount: damData.damList.count,
            dataStorm: stormDatas,
            stormCount: stormDatas.length,
            dataRainfallForecast,
            dataDisaster,
            dataDrought,
            dataSalinity: [],
            dataFlashflood,
            dataSituationAlert: situationAlert,
            dataEarlyWarning: [],
          };
          setDataAll(varDataAll);
        })
        .catch((err) => setError(`fetch Promise.all ${err.message}`))
        .finally(() => {
          setLoading(false);
        });
    };

    const fetchEws = async () => {
      try {
        // Use Promise.race to race between the fetch and a timeout
        const response = await Promise.race([
          fetch(`${process.env.REACT_APP_API_BACKOFFICE_URL}/risk/dwr/ews`),
          new Promise((_, reject) => setTimeout(() => reject(new Error('Request timed out')), FETCH_TIMEOUT)),
        ]);

        if (!response.ok) {
          throw new Error(`Request failed with status ${response.status}`);
        }

        const data = await response.json();
        const earlyWarningData = data.data;
        mainData.current.warning = earlyWarningData;
        dataEarlyWarning = setEwsWarning(earlyWarningData);

        // setDataAll([...dataAll, dataEarlyWarning]);
        setDataAll({ ...dataAll, dataEarlyWarning });
      } catch (errorFetchEws) {
        setError(`fetchEws${errorFetchEws.message}`);
      } finally {
        setLoading(false);
      }
    };

    const fetchWarningSalinity = async () => {
      try {
        // Use Promise.race to race between the fetch and a timeout
        const response = await Promise.race([
          fetch(`${process.env.REACT_APP_FEWS_URL}/model-output/data_portal/mwa_salinity/warning_salinity.csv`),
          new Promise((_, reject) => setTimeout(() => reject(new Error('Request timed out')), FETCH_TIMEOUT)),
        ]);
        if (!response.ok) {
          throw new Error(`Request failed with status ${response.status}`);
        }
        const data = await response.text();
        let salinityArray = [];
        if (data.length > 0) {
          salinityArray = Papa.parse(data).data.slice(1);
        }
        mainData.current.salinity = salinityArray.length > 0 ? salinityArray : [];
        dataSalinity = setSalinity(salinityArray);

        // setDataAll([...dataAll, dataSalinity]);
        setDataAll({ ...dataAll, dataSalinity });
      } catch (errorFetchWarningSalinity) {
        setError(`fetchWarningSalinity ${errorFetchWarningSalinity.message}`);
      } finally {
        setLoading(false);
      }
    };

    if (currentMode !== '') {
      fetchData();
      fetchEws();
      fetchWarningSalinity();

      const queryParams = new URLSearchParams(location.search);
      const errorMessage = queryParams.get('status');
      if (errorMessage) {
        setThaidStatus(errorMessage);
        console.log(errorMessage);
      }
    }
  }, [currentMode]);

  // useEffect(() => {
  //   const fetchData = async () => {
  //     setLoading(true);

  //     Promise.all([
  //       fetch(`${process.env.REACT_APP_API_URL}/public/thailand`),
  //       fetch(`${process.env.REACT_APP_API_BACKOFFICE_URL}/disaster`),
  //       fetch(`${process.env.REACT_APP_FEWS_URL}/model-output/data_portal/flashflood/flashflood_report.txt`),
  //       fetch(`${process.env.REACT_APP_FEWS_URL}/model-output/data_portal/mwa_salinity/warning_salinity.csv`),
  //       fetch(`${process.env.REACT_APP_FEWS_URL}/model-output/data_portal/drought/drought_report.txt`),
  //       fetch(`${process.env.REACT_APP_API_BACKOFFICE_URL}/onwr/content/announce`),
  //       fetch(`${process.env.REACT_APP_API_BACKOFFICE_URL}/risk/dwr/ews`),
  //     ])
  //       .then(([res1, res2, res3, res4, res5, res6, res7]) => Promise.all([res1.json(), res2.json(),
  //         res3.text(), res4.text(), res5.text(), res6.json(), res7.json(),
  //       ]))
  //       .then(([
  //         result, resultDisaster, resultFlashFlood,
  //         resultSalinity, resutDrought, resultSituation,
  //         resultEws]) => {
  //         mainData.current.thailand = result;
  //         rainData = setRain(result.rain);
  //         wqData = setWaterQualityData(result.waterquality.data.data);
  //         wlData = setWlData(result.waterlevel.data.data);
  //         waveData = setWaveData(result.wave.data.data);
  //         // waveData =  setWaveData(mockDataWave);
  //         stormDatas = result.storm.data.data;
  //         damData = setDam(result.dam.data.data);
  //         dataRainfallForecast = result.pre_rain.data.data;

  //         mainData.current.dis = resultDisaster;
  //         dataDisaster = setDisaster(resultDisaster.data);

  //         const flashfloodArray = Papa.parse(resultFlashFlood).data.slice(1, -1);
  //         mainData.current.flashflood = flashfloodArray;
  //         dataFlashflood = setFlashflood(flashfloodArray);

  //         const salinityArray = Papa.parse(resultSalinity).data.slice(1);
  //         mainData.current.salinity = salinityArray;
  //         dataSalinity = setSalinity(salinityArray);

  //         const droughtArray = Papa.parse(resutDrought).data.slice(1, -1);
  //         mainData.current.drought = droughtArray;
  //         dataDrought = setDrought(droughtArray);

  //         const situationAlert = resultSituation.data;
  //         const earlyWarningData = resultEws.data;

  //         const varDataAll = {
  //           rainList: rainData.RainList,
  //           dataRain: rainData.dataFilterArea,
  //           rainCount: rainData.RainList.count,
  //           waveCount: waveData.waveCount,
  //           waveList: waveData.waveList,
  //           dataWave: waveData.waveDataFilterArea,
  //           wqCount: wqData.wqCount,
  //           wqList: wqData.wqList,
  //           dataWaterQuality: wqData.wqFilterLevel,
  //           wlRedCount: wlData.wlRedCount,
  //           wlList: wlData.wlList,
  //           dataWaterLevel: wlData.wlFilterLevel,
  //           dataDam: damData.damList,
  //           damCount: damData.damList.count,
  //           dataStorm: stormDatas,
  //           stormCount: stormDatas.length,
  //           dataRainfallForecast,
  //           dataDisaster,
  //           dataDrought,
  //           dataSalinity,
  //           dataFlashflood,
  //           dataSituationAlert: situationAlert,
  //           dataEarlyWarning: earlyWarningData,
  //         };
  //         setDataAll(varDataAll);
  //       })
  //       .catch((err) => setError(err))
  //       .finally(() => {
  //         setLoading(false);
  //       });
  //   };

  //   // if (currentMode !== '') {
  //   //   fetchData();
  //   // }

  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [currentMode]);

  useEffect(() => {
    if (mainData.current.thailand) {
      const data = mainData.current.thailand;

      rainData = setRain(data.rain);
      // setRain(testrain);
      wqData = setWaterQualityData(data.waterquality.data.data);
      wlData = setWlData(data.waterlevel.data.data);
      waveData = setWaveData(data.wave.data.data);
      // setWaveData(mockDataWave)
      stormDatas = data.storm.data.data;
      damData = setDam(data.dam.data.data);
      dataRainfallForecast = data.pre_rain.data.data;
    }

    if (mainData.current.dis && mainData.current.drought && mainData.current.salinity
      && mainData.current.flashflood) {
      dataDisaster = setDisaster(mainData.current.dis.data);
      dataDrought = setDrought(mainData.current.drought);
      dataSalinity = setSalinity(mainData.current.salinity);
      dataFlashflood = setFlashflood(mainData.current.flashflood);
    }

    // ews warning, show data when in thailand
    const dataEws = setEwsWarning(mainData.current.warning);

    if (!isEmpty(rainData)) {
      const varDataAll = {
        rainList: rainData.RainList,
        dataRain: rainData.dataFilterArea,
        rainCount: rainData.RainList.count,
        waveCount: waveData.waveCount,
        waveList: waveData.waveList,
        dataWave: waveData.waveDataFilterArea,
        wqCount: wqData.wqCount,
        wqList: wqData.wqList,
        dataWaterQuality: wqData.wqFilterLevel,
        wlRedCount: wlData.wlRedCount,
        wlList: wlData.wlList,
        dataWaterLevel: wlData.wlFilterLevel,
        dataDam: damData.damList,
        damCount: damData.damList.count,
        dataStorm: stormDatas,
        stormCount: stormDatas.length,
        dataRainfallForecast,
        dataDisaster,
        dataDrought,
        dataSalinity,
        dataFlashflood,
        dataEarlyWarning: dataEws,
      };
      setDataAll(varDataAll);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentMode, currentArea]);

  // reset modal while changing from desktop to mobile with the modal previously open
  useEffect(() => {
    setIsModalOpen(false);
    setModalData({
      header: '',
      subheader: null,
      content: null,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [(<Hidden mdUp />).props.mdUp, currentMode, currentArea]);

  // force modal close
  useEffect(() => {
    if (modalData.open) modalData.open = false;
  }, [modalData.open]);

  return (
    <>
      {console.log('Error => ', error)}
      {/* {error && <div>Error Occured</div>} */}
      {isLoading && (
        <div className="Loading">
          <CircularProgress />
        </div>
      )}

      <Fragment key="key">
        <Grid
          container
          direction="column"
          spacing={0}
          style={{
            position: 'fixed',
            bottom: 50,
            left: 0,
            zIndex: 999,
            padding: 20,
            width: '50%',
          }}
        >
          <Grid item>
            <Snackbar
              open={openModal}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              style={{ position: 'relative', bottom: 'auto', left: 'auto', transform: 'none' }}
              ContentProps={{
                style: { padding: 0 }
              }}
              message={
                (
                  <Box display="flex" onClick={handlenewtabSituation()} style={{ textDecorationLine: 'none' }}>
                    <Alert
                      icon={<InfoIcon fontSize="inherit" />}
                      severity="warning"
                      style={{
                        backgroundColor: '#D97603',
                        fontSize: '1.1em',
                        fontStyle: 'italic',
                        fontWeight: 400,
                        fontFamily: 'Kanit',
                      }}
                    >
                      <Box display="flex" alignItems="center" minWidth={{ xs: 200, sm: 255, md: 261 }} className={classes.btn}>อินโฟกราฟิกติดตามสถานการณ์ลุ่มน้ำ</Box>
                    </Alert>
                  </Box>
                )
              }
              action={
                (
                  <IconButton size="small" aria-label="close" onClick={() => setOpenModal(false)} style={{ backgroundColor: '#D97603' }} title="close">
                    <CloseIcon fontSize="small" style={{ color: 'white' }} />
                  </IconButton>
                )
              }
            />
          </Grid>

          <Grid item>
            <Snackbar
              open={openNoti}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              style={{ position: 'relative', bottom: 'auto', left: 'auto', transform: 'none' }}
              ContentProps={{
                style: { padding: 0 }
              }}
              message={
                (
                  <Box display="flex" onClick={handleSituationAlert(dataAll.dataSituationAlert)} style={{ textDecorationLine: 'underline' }}>
                    <Alert
                      icon={<WarningIcon fontSize="inherit" />}
                      severity="warning"
                      style={{
                        backgroundColor: '#C1413A',
                        fontSize: '1.2em',
                        fontStyle: 'italic',
                        fontWeight: 400,
                        fontFamily: 'Kanit',
                      }}
                    >
                      <Box display="flex" alignItems="center" minWidth={{ xs: 200, sm: 255, md: 261 }} className={classes.btn}>ประกาศ! แจ้งเตือนสถานการณ์</Box>
                    </Alert>
                  </Box>
                )
              }
              action={
                (
                  <IconButton size="small" aria-label="close" onClick={() => setOpenNoti(false)} style={{ backgroundColor: '#C1413A' }} title="close">
                    <CloseIcon fontSize="small" style={{ color: 'white' }} />
                  </IconButton>
                )
              }
            />
          </Grid>

          <Grid item>
            <Snackbar
              open={openHatyai68}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              style={{ position: 'relative', bottom: 'auto', left: 'auto', transform: 'none' }}
              ContentProps={{
                style: { padding: 0 }
              }}
              message={
                (
                  <Link href={`${initPath}hatyai68/`} target="_blank" title="ติดตามสถานการณ์น้ำท่วมหาดใหญ่">
                    <Alert
                      icon={<DvrIcon fontSize="inherit" />}
                      severity="warning"
                      style={{
                        backgroundColor: '#228e1d',
                        fontSize: '1.2em',
                        fontStyle: 'italic',
                        fontWeight: 400,
                        fontFamily: 'Kanit',
                      }}
                    >
                      <Box display="flex" alignItems="center" minWidth={{ xs: 200, sm: 255, md: 261 }} className={classes.btn} style={{ cursor: 'pointer' }}>ติดตามสถานการณ์น้ำท่วมหาดใหญ่</Box>
                    </Alert>
                  </Link>
                )
              }
              action={
                (
                  <IconButton size="small" aria-label="close" onClick={() => setOpenHatyai68(false)} style={{ backgroundColor: '#228e1d' }} title="close">
                    <CloseIcon fontSize="small" style={{ color: 'white' }} />
                  </IconButton>
                )
              }
            />
          </Grid>

          <Grid item>
            <Snackbar
              open={openHatyaiFlood}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              style={{ position: 'relative', bottom: 'auto', left: 'auto', transform: 'none' }}
              ContentProps={{
                style: { padding: 0 }
              }}
              message={
                (
                  <Link href={`${initPath}hatyai68-flood-area/`} target="_blank" title="วิเคราะห์ระดับน้ำลด จาก Lidar และ DEM">
                    <Alert
                      icon={<RoomIcon fontSize="inherit" />}
                      severity="warning"
                      style={{
                        backgroundColor: '#0a6662',
                        fontSize: '1em',
                        fontStyle: 'italic',
                        fontWeight: 400,
                        fontFamily: 'Kanit',
                      }}
                    >
                      <Box display="flex" alignItems="center" minWidth={{ xs: 200, sm: 255, md: 261 }} className={classes.btn} style={{ cursor: 'pointer' }}>วิเคราะห์ระดับน้ำลด จาก Lidar และ DEM</Box>
                    </Alert>
                  </Link>
                )
              }
              action={
                (
                  <IconButton size="small" aria-label="close" onClick={() => setOpenHatyaiFlood(false)} style={{ backgroundColor: '#0a6662' }} title="close">
                    <CloseIcon fontSize="small" style={{ color: 'white' }} />
                  </IconButton>
                )
              }
            />
          </Grid>
          <Grid item>
            <Snackbar
              open={openStationFloodArea}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              style={{ position: 'relative', bottom: 'auto', left: 'auto', transform: 'none' }}
              ContentProps={{
                style: { padding: 0 }
              }}
              message={
                (
                  <Link href={`${initPath}stationfloodarea/`} target="_blank" title="พื้นที่น้ำท่วม จากเกณฑ์สถานีวัดระดับน้ำ">
                    <Alert
                      icon={<RoomIcon fontSize="inherit" />}
                      severity="warning"
                      style={{
                        backgroundColor: '#076eac',
                        fontSize: '1em',
                        fontStyle: 'italic',
                        fontWeight: 400,
                        fontFamily: 'Kanit',
                      }}
                    >
                      <Box display="flex" alignItems="center" minWidth={{ xs: 200, sm: 255, md: 261 }} className={classes.btn} style={{ cursor: 'pointer' }}>พื้นที่น้ำท่วม จากเกณฑ์สถานีวัดระดับน้ำ</Box>
                    </Alert>
                  </Link>
                )
              }
              action={
                (
                  <IconButton size="small" aria-label="close" onClick={() => setOpenStationFloodArea(false)} style={{ backgroundColor: '#076eac' }} title="close">
                    <CloseIcon fontSize="small" style={{ color: 'white' }} />
                  </IconButton>
                )
              }
            />
          </Grid>
          <Grid item>
            <Snackbar
              open={openBanner}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              style={{ position: 'relative', bottom: 'auto', left: 'auto', transform: 'none' }}
              ContentProps={{
                style: { padding: 0 }
              }}
              message={
                (
                  <Link href="https://devsupport.hii.or.th/" target="_blank" title="แจ้งปัญหาการใช้งานเว็บไซต์">
                    <Alert icon={<InfoIcon fontSize="inherit" />} severity="info" style={{ backgroundColor: '#033375' }} minwidth={{ xs: 200, sm: 255, md: 255 }}>
                      <Box display="flex">
                        <Box display="block" flexDirection="column" minWidth={{ xs: 200, sm: 255, md: 215 }}>
                          <Box
                            style={{
                              fontSize: '1.1em',
                              fontStyle: 'italic',
                              fontWeight: 400,
                              fontFamily: 'Kanit',
                            }}
                          >
                            แจ้งปัญหาการใช้งานเว็บไซต์
                          </Box>
                          <Box display="flex" flexDirection="row" alignItems="center" style={{ fontSize: '0.8em', fontFamily: 'Kanit' }}>
                            หากพบเห็น
                            <Box mx={1} style={{ fontSize: '0.9em', fontStyle: 'italic', textDecorationLine: 'underline' }}>ปัญหาการใช้งาน</Box>
                            สามารถแจ้งได้ที่นี่
                          </Box>
                        </Box>
                        <Hidden smDown><Box><img src={HandIcon} alt="" /></Box></Hidden>
                      </Box>
                    </Alert>
                  </Link>
                )
              }
              action={
                (
                  <IconButton size="small" aria-label="close" onClick={() => setOpenBanner(false)} style={{ backgroundColor: '#033375' }} title="close">
                    <CloseIcon fontSize="small" style={{ color: 'white' }} />
                  </IconButton>
                )
              }
            />
          </Grid>

          {thaidStatus === 'notbindid' && (
            <Grid item>
              <Snackbar
                open={openAlertThaid}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'left',
                }}
                style={{ position: 'relative', bottom: 'auto', left: 'auto', transform: 'none' }}
                ContentProps={{
                  style: { padding: 0 }
                }}
                message={
                  (
                    <Box display="flex">
                      <Alert
                        icon={<WarningIcon fontSize="inherit" />}
                        onClose={handleClose}
                        severity="warning"
                        style={{
                          backgroundColor: '#f44336',
                          marginBottom: 75,
                          fontSize: '1.2em',
                          fontWeight: 400,
                          fontFamily: 'Kanit',
                        }}
                      >
                        <Box display="flex" alignItems="center" minWidth={{ xs: 200, sm: 255, md: 200 }} className={classes.btn}>คุณยังไม่ได้ผูกข้อมูล ThaID</Box>
                      </Alert>
                    </Box>
                  )
                }
                action={
                  (
                    <IconButton size="small" aria-label="close" onClick={() => closeAlertThaid()} style={{ backgroundColor: '#C1413A', marginBottom: 75 }} title="close">
                      <CloseIcon fontSize="small" style={{ color: 'white' }} />
                    </IconButton>
                  )
                }
              />
            </Grid>
          )}

        </Grid>

        {/* Cookie */}
        <CookieConsent
          location="bottom"
          buttonText="ยอมรับ"
          cookieName="PDPA-NTW"
          style={{ background: 'rgb(255, 255, 255, 0.9)', borderTop: '1px solid #ccc', zIndex: 999999 }}
          buttonStyle={{
            background: '#1876D2', color: '#fff', fontSize: '0.9em', borderRadius: 20, padding: '3px 25px', marginleft: 20, fontFamily: 'Kanit',
          }}
          expires={150}
        >
          <h4 style={{ color: '#000', lineHeight: '100%', fontFamily: 'Kanit' }}>นโยบายและคำประกาศเกี่ยวกับความเป็นส่วนตัว</h4>
          <p style={{
            color: '#666', fontSize: '0.9em', marginBottom: 5, fontFamily: 'Kanit',
          }}
          >
            เราให้ความสำคัญต่อข้อมูลส่วนบุคคลของท่าน เพื่อการพัฒนาประสิทธิภาพ
            และประสบการณ์ที่ดีในการใช้งานเว็บไซต์ หากท่านใช้บริการเว็บไซต์นี้
          </p>
          <Grid container spacing={2}>
            <Grid item xs={12} md="auto"><span style={{ color: '#000' }}>ดูรายละเอียดเพิ่มเติม :  </span></Grid>
            <Grid item xs={12} sm="auto"><a href={`${initPath}pdpa`}><span className={classes.pdpaPopupLink}>นโยบายการคุ้มครองข้อมูลส่วนบุคคล</span></a></Grid>
          </Grid>
        </CookieConsent>
      </Fragment>

      <Map
        id="map"
        ref={refMap}
        zoomControl={false}
        center={currentArea.location ? currentArea.location : mapConfig.center}
        zoomSnap={0}
        boundsOptions={{ padding: [90, 90] }}
        zoomDelta={0.5}
        bounds={L.latLngBounds(currentArea.top_left, currentArea.bottom_right)}
        className={classes.boxMap}
      >
        <TileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          attribution="&copy; <a href=&quot;http://osm.org/copyright&quot;>OpenStreetMap</a> contributors"
          opacity={0.45}
        />
        {currentMode === 'province' && (
          <LayerProvince
            areaType={0}
            areaId={currentArea.code}
            areaFill
            areaFillColor="#fff"
            areaFillOpacity={0.75}
            areaStroke
            areaWeight={1}
            areaStrokeColor="#999"
            areaCurrentStroke
            areaCurrentStrokeColor=""
            areaCurrentFillColor=""
            areaCurrentFillOpacity={0}
            areaCurrentWeight={2}
          />
        )}
        {currentMode === 'basin' && (
          <LayerBasin
            areaType={1}
            areaId={currentArea.code}
            areaFill
            areaFillColor="#fff"
            areaFillOpacity={0.75}
            areaStroke
            areaWeight={1}
            areaStrokeColor="#999"
            areaCurrentStroke
            areaCurrentStrokeColor=""
            areaCurrentFillColor=""
            areaCurrentFillOpacity={0}
            areaCurrentWeight={2}
          />
        )}
        {!isEmpty(currentMode) && !isEmpty(dataAll.dataRainfallForecast) && (
          <RainfallForecastMap
            datas={dataAll.dataRainfallForecast}
            currentMode={currentMode}
            currentAreaCode={currentArea.code}
          />
        )}

        {!isEmpty(dataAll.dataWaterLevel) && (<WaterLevelMap datas={dataAll.dataWaterLevel} />)}
        {!isEmpty(dataAll.dataWaterQuality) && (
          <WaterQualityMap datas={dataAll.dataWaterQuality} />
        )}
        {!isEmpty(dataAll.dataWave) && (<WaveMap datas={dataAll.dataWave} />)}
        {!isEmpty(dataAll.dataRain) && (<Rain24Map datas={dataAll.dataRain} />)}
        {!isEmpty(dataAll.dataDam) && (<DamMap datas={dataAll.dataDam} />)}
        {!isEmpty(dataAll.dataDisaster) && (<DisasterMap datas={dataAll.dataDisaster} />)}
        {!isEmpty(dataAll.dataEarlyWarning) && (
          <EarlyWarningMap datas={dataAll.dataEarlyWarning} />
        )}

        {/* <ReactLeafletKmz url={SampleKmz} /> */}
        {/* <StormLatest datas={dataStorm} /> */}
        <Jtwc />
        <LayerRiver />
        {currentMode === 'province' && (<WmsBoundary />)}
        {currentMode === 'basin' && (<WmsBasin />)}
      </Map>
      <Hidden smDown>
        <Box>
          <Box><BoxView /></Box>
          <Box><FooterMap /></Box>
        </Box>
      </Hidden>
      <Hidden mdUp>
        <Mobile />
      </Hidden>
      <FooterMap />

      <Modal
        open={isModalOpen}
        modalHeader={modalData.header}
        modalSubHeader={modalData.subheader}
        modalContent={modalData.content}
        modalStyle={modalData.style}
        resetModal={handleModalClose}
      />
    </>
  );
}

Main.defaultProps = {
  page: '',
};

Main.propTypes = {
  // eslint-disable-next-line react/no-unused-prop-types
  page: PropTypes.string,
};
